import ufeApi from 'services/api/ufeApi';

// Edit the existing address that is already assigned to the subscription https://jira.sephora.com/browse/SUBS-199

function updateSubscriptionWithExistingAddress(subscriptionId, addressPaymentData = {}) {
    const { sdnUfeAPIUserKey } = Sephora.configurationSettings;
    const { country, language } = Sephora.renderQueryParams;
    const { addressId } = addressPaymentData;
    const url = `/gway/v1/replenishment/${subscriptionId}/addresses/${addressId}?apikey=${sdnUfeAPIUserKey}`;

    const options = {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Site-Locale': country,
            'Site-Language': language
        },
        body: JSON.stringify(addressPaymentData)
    };

    return ufeApi.makeRequest(url, options).then(data => (data.errors || data?.responseStatus >= 400 ? Promise.reject(data) : data));
}

export default { updateSubscriptionWithExistingAddress };
